import React from 'react';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { oddStore } from '../../../store/oddStore';
import { pigClassNames } from '../../../enums/pigEnums';
import { gameStore } from '../../../store/gameStore';

function PigImage({ itemId, isSave, winAmount, oddCurrentValue }) {
  const { pigIndex, bonusMultiplier } = gameStore.multiplierData;
  const { second } = roundInfoStore;

  return (
    <div className='c-m-bets-item-img'>
      <div className={`c-m-bets-item-img-popover open large ${isSave ? 'failure' : ''}`}>
        {oddStore.isShowCloud ? (
          <div className='c-m-cloud-holder'>
            <svg
              width='121'
              height='68'
              viewBox='0 0 121 68'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g opacity='0.96'>
                <path
                  d='M3 34.4239C3 25.248 11.9625 17.6794 23.5494 16.5486C26.2736 8.34749 35.7264 2.30386 46.9501 2.30386C49.8318 2.29356 52.6987 2.69813 55.454 3.50392C56.6088 2.2194 58.0851 1.23418 59.7457 0.639782C61.4063 0.0453807 63.1974 -0.138926 64.9526 0.103982C66.7079 0.346891 68.3703 1.00914 69.7856 2.0292C71.2008 3.04927 72.3229 4.39407 73.0477 5.9387C75.1634 4.96009 77.4842 4.45202 79.8354 4.45271C87.8082 4.45271 94.4461 10.2061 95.9126 17.8267C97.2318 17.6504 98.5623 17.5621 99.8944 17.5624C112.653 17.5624 121 25.3606 121 34.9958C121 42.9327 115.972 47.6261 106.36 49.736C106.36 49.9916 106.36 50.2429 106.36 50.4985C106.36 60.164 98.042 67.9969 87.7809 67.9969C83.4071 68.0059 79.1692 66.5475 75.8082 63.8768C71.4378 66.6786 66.2637 68.1168 61.0002 67.9926C55.7366 67.8684 50.6433 66.1881 46.4234 63.1836C43.2356 64.6136 39.7528 65.3449 36.2304 65.3238C25.3337 65.3238 16.5028 58.6563 16.5028 50.4335C16.5038 49.8739 16.5463 49.3151 16.63 48.7612C8.58909 45.8932 3 41.6546 3 34.4239Z'
                  fill='#ADADAD'
                />
                <path
                  d='M4.3045 33.7915C4.3045 24.7811 13.0686 17.3455 24.4062 16.2445C27.0849 8.19036 36.3116 2.25069 47.3011 2.25069C50.1182 2.24683 52.9198 2.64906 55.612 3.44389C56.7418 2.18156 58.1863 1.21329 59.8113 0.629041C61.4364 0.0447882 63.1892 -0.136494 64.9069 0.102036C66.6247 0.340566 68.2516 0.991172 69.6366 1.9934C71.0216 2.99564 72.1197 4.31698 72.8289 5.83467C74.8971 4.8742 77.1655 4.37479 79.4639 4.37388C87.2481 4.37388 93.764 10.0284 95.1972 17.5078C96.487 17.3381 97.7875 17.2531 99.0894 17.2534C111.572 17.2534 120.696 23.9171 120.696 33.3618C120.696 41.157 114.827 46.7328 105.413 48.8033C105.413 49.0534 105.436 49.3034 105.436 49.5535C105.436 59.0464 97.2944 66.7408 87.2573 66.7408C82.9762 66.7528 78.827 65.3227 75.5351 62.7006C71.2595 65.4522 66.1979 66.8645 61.0488 66.7427C55.8996 66.6209 50.9169 64.971 46.7883 62.0206C43.6703 63.4235 40.2645 64.1414 36.8198 64.1219C26.16 64.1219 17.5194 57.5769 17.5194 49.4965C17.5214 48.9475 17.5627 48.3993 17.6431 47.8558C9.76721 45.0395 4.3045 40.9112 4.3045 33.7915Z'
                  fill='white'
                />
              </g>
              <path
                d='M10.4719 61.0073C8.6011 61.0073 7.0845 59.4907 7.0845 57.6199C7.0845 55.749 8.6011 54.2324 10.4719 54.2324C12.3428 54.2324 13.8594 55.749 13.8594 57.6199C13.8594 59.4907 12.3428 61.0073 10.4719 61.0073Z'
                fill='white'
              />
              <path
                d='M2.63625 62.7815C2.32418 61.574 3.05011 60.3421 4.25766 60.03C5.46521 59.718 6.6971 60.4439 7.00917 61.6514C7.32124 62.859 6.59531 64.0909 5.38776 64.4029C4.18021 64.715 2.94832 63.9891 2.63625 62.7815Z'
                fill='white'
              />
              <path
                d='M8.29697e-05 66.4939C-0.000348091 66.7484 0.0747643 66.9974 0.215916 67.2092C0.357068 67.421 0.55791 67.5862 0.793002 67.6838C1.02809 67.7814 1.28686 67.8071 1.53654 67.7575C1.78622 67.708 2.01558 67.5855 2.19558 67.4055C2.37557 67.2255 2.49811 66.9961 2.54766 66.7464C2.59722 66.4967 2.57156 66.238 2.47395 66.0029C2.37634 65.7678 2.21116 65.567 1.99933 65.4258C1.7875 65.2847 1.53854 65.2095 1.28399 65.21C0.943478 65.21 0.61691 65.3452 0.37613 65.586C0.13535 65.8268 8.29697e-05 66.1534 8.29697e-05 66.4939Z'
                fill='white'
              />
            </svg>
            <p className='c-m-bets-item-img-popover-txt'>x{oddCurrentValue}</p>
          </div>
        ) : (
          <> </>
        )}
        {!gameStore.isPigMultiplierInvisible ? (
          <div
            className={`multiplier-block ${
              // eslint-disable-next-line no-nested-ternary
              gameStore.isPigMultiplierInvisible
                ? 'invisible'
                : pigIndex === itemId && gameStore.isBetsClosed
                ? ''
                : 'invisible'
            }`}
            data-multiply={`x${bonusMultiplier || ''}`}
            style={{
              transitionDelay: `${gameStore.isBetsClosed ? -second : -2}s`,
            }}
          />
        ) : (
          <> </>
        )}
      </div>
      <div className='c-m-bets-item-img-inner'>
        <div
          className={`pig-image-holder ${pigClassNames[itemId]} ${winAmount ? 'animate' : ''}`}
        />
      </div>
    </div>
  );
}

export default PigImage;
